import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0b91d262"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid py-4" }
const _hoisted_2 = { class: "page-header mb-4" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "header-title" }, "Mes devoirs soumis"),
  /*#__PURE__*/_createElementVNode("p", { class: "header-subtitle" }, "Consultez et gérez tous vos devoirs soumis")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-2" }, null, -1))
const _hoisted_6 = { class: "row mb-4 g-4" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "stat-card card-info" }
const _hoisted_9 = { class: "stat-card-inner" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stat-icon icon-info" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-inbox" })
  ])
], -1))
const _hoisted_11 = { class: "stat-content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Total soumis", -1))
const _hoisted_13 = { class: "stat-number" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "stat-card card-warning" }
const _hoisted_16 = { class: "stat-card-inner" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stat-icon icon-warning" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock-o" })
  ])
], -1))
const _hoisted_18 = { class: "stat-content" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "En attente", -1))
const _hoisted_20 = { class: "stat-number" }
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "stat-card card-primary" }
const _hoisted_23 = { class: "stat-card-inner" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stat-icon icon-primary" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pencil" })
  ])
], -1))
const _hoisted_25 = { class: "stat-content" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "En correction", -1))
const _hoisted_27 = { class: "stat-number" }
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = { class: "stat-card card-success" }
const _hoisted_30 = { class: "stat-card-inner" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stat-icon icon-success" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle" })
  ])
], -1))
const _hoisted_32 = { class: "stat-content" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "Corrigés", -1))
const _hoisted_34 = { class: "stat-number" }
const _hoisted_35 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "loading-text mt-3" }, "Chargement...", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  class: "modern-card"
}
const _hoisted_40 = { class: "card-body" }
const _hoisted_41 = { class: "empty-state-content" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-inbox" })
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "empty-title" }, "Aucun devoir soumis", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "empty-text" }, "Commencez par soumettre votre premier devoir", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-2" }, null, -1))
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { class: "row g-3 g-md-4" }
const _hoisted_48 = { class: "devoir-card-clean" }
const _hoisted_49 = { class: "card-header-clean" }
const _hoisted_50 = { class: "title" }
const _hoisted_51 = { class: "card-body-clean" }
const _hoisted_52 = { class: "info" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Matière :", -1))
const _hoisted_54 = { class: "info" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Date de soumission :", -1))
const _hoisted_56 = {
  key: 0,
  class: "info note"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Note :", -1))
const _hoisted_58 = { class: "big-note" }
const _hoisted_59 = {
  key: 1,
  class: "comment-box"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "comment-title" }, "Commentaire du professeur", -1))
const _hoisted_61 = { class: "comment-text" }
const _hoisted_62 = { class: "card-footer-clean" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = {
  key: 0,
  class: "pagination-container mt-4"
}
const _hoisted_66 = { class: "pagination-list" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "modal-dialog-pdf" }
const _hoisted_69 = { class: "modal-content-modern" }
const _hoisted_70 = { class: "modal-header-pdf" }
const _hoisted_71 = { class: "modal-title" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-pdf-o me-2" }, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = { class: "modal-body-pdf" }
const _hoisted_76 = ["src"]
const _hoisted_77 = { class: "modal-footer-pdf" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "/soumettre-devoir",
          class: "btn-header-action"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Soumettre un devoir ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.stats.total), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.stats.soumis), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.stats.enCours), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.stats.corriges), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))
      : (_ctx.devoirs.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _hoisted_43,
                _hoisted_44,
                _createVNode(_component_router_link, {
                  to: "/soumettre-devoir",
                  class: "btn-empty-action"
                }, {
                  default: _withCtx(() => [
                    _hoisted_45,
                    _createTextVNode(" Soumettre un devoir ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devoirs, (devoir) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: devoir.id,
                  class: "col-12 col-md-6 col-lg-4"
                }, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("h6", _hoisted_50, _toDisplayString(devoir.composition?.titre), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(['status-tag', _ctx.getStatutClass(devoir.statut)])
                      }, _toDisplayString(_ctx.getStatutLabel(devoir.statut)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createTextVNode(" " + _toDisplayString(devoir.composition?.filiereNiveauMatiere?.matiere?.libelle), 1)
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateShort(devoir.dateSoumission)), 1)
                      ]),
                      (devoir.note !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _hoisted_57,
                            _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.formatNote(devoir.note)) + "/20", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (devoir.commentaire)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _hoisted_60,
                            _createElementVNode("div", _hoisted_61, _toDisplayString(devoir.commentaire), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.viewDevoirPdf(devoir)),
                        class: "btn-small"
                      }, "Voir", 8, _hoisted_63),
                      (devoir.statut !== 'corrige')
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/modifier-devoir/${devoir.id}`,
                            class: "btn-small edit"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Modifier")
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (devoir.fichierCorrigeUrl)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.downloadDevoir(devoir, 'corrige')),
                            class: "btn-small success"
                          }, "Corrigé", 8, _hoisted_64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            (_ctx.totalPages > 1)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_65, [
                  _createElementVNode("ul", _hoisted_66, [
                    _createElementVNode("li", {
                      class: _normalizeClass(["pagination-item", { disabled: _ctx.currentPage === 1 }])
                    }, [
                      _createElementVNode("a", {
                        class: "pagination-link",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                      }, " Précédent ")
                    ], 2),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: page,
                        class: _normalizeClass(["pagination-item", { active: page === _ctx.currentPage }])
                      }, [
                        _createElementVNode("a", {
                          class: "pagination-link",
                          onClick: ($event: any) => (_ctx.changePage(page))
                        }, _toDisplayString(page), 9, _hoisted_67)
                      ], 2))
                    }), 128)),
                    _createElementVNode("li", {
                      class: _normalizeClass(["pagination-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                    }, [
                      _createElementVNode("a", {
                        class: "pagination-link",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                      }, " Suivant ")
                    ], 2)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])),
    (_ctx.showPdfModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "modal-overlay",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("h5", _hoisted_71, [
                  _hoisted_72,
                  _createTextVNode(_toDisplayString(_ctx.currentPdfTitle), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close-modal",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)))
                }, _hoisted_74)
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("iframe", {
                  src: _ctx.currentPdfUrl,
                  class: "pdf-iframe",
                  title: "Visualiseur PDF"
                }, null, 8, _hoisted_76)
              ]),
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-modal-secondary",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)))
                }, "Fermer")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}